exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image-uploader .el-upload-list--picture-card .el-upload-list__item-thumbnail {\n  -o-object-fit: cover;\n     object-fit: cover;\n}", ""]);

// exports
